module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};


//////////////////
// WEBPACK FOOTER
// ./~/dom-serializer/~/entities/lib/maps/xml.json
// module id = 235
// module chunks = 0